export interface Span {
  left: number
  right: number
}

export interface RowView {
  scrollLeft: number
  width: number
  inset: number
}

export function revealedScrollLeft(
  { scrollLeft, width, inset }: RowView,
  applied: Span[],
  used: Span | null,
): number {
  const wanted = used ? [...applied, used] : applied
  const first = wanted[0]
  if (!first) return scrollLeft

  const room = width - 2 * inset
  const left = Math.min(...wanted.map((span) => span.left))
  const right = Math.max(...wanted.map((span) => span.right))
  const shown = right - left <= room ? { left, right } : (used ?? first)

  if (shown.left - inset < scrollLeft) return shown.left - inset
  if (shown.right + inset > scrollLeft + width) return shown.right + inset - width
  return scrollLeft
}
